module.exports = __webpack_public_path__ + "img/Logo.93363419.svg";